<template>
  <div class="delete-tip">
    <img class="warning-img" src="@/assets/views/map/icon/warning.png" alt />
    <span class="warning-text">删除标注地图将清除所有路径数据</span>
    <span class="warning-text">确认删除？</span>
    <div class="btn">
      <div class="yes-btn" @click="del">确认</div>
      <div class="no-btn" @click="noDel">取消</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "deleteMap",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    del() {
      this.$emit("del", !0);
    },
    noDel() {
      this.$emit("notdel", !!0);
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin center() {
  display: flex;
  justify-content: center;
  align-items: center;
}
.delete-tip {
  @include center;
  flex-direction: column;
  .warning-img {
    width: 23.3px;
    height: 23.3px;
  }
  .warning-text {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
  }
  .btn {
    display: flex;
    flex-wrap: nowrap;
    margin-top: 20px;
    :hover {
      cursor: pointer;
    }
    .yes-btn {
      border: 1px solid #ff3b30;
      border-radius: 4px;
      width: 123px;
      height: 30px;
      @include center;
      margin-right: 20px;
    }
    .no-btn {
      border: 1px solid #adadad;
      border-radius: 4px;
      width: 123px;
      height: 30px;
      @include center;
      margin-left: 20px;
    }
  }
}
</style>
